/**
 * 
 * Input Box
 * 
 */

import React from 'react';
import {Checkbox} from 'primereact/checkbox';

class CheckBox extends React.Component {

    render() {
        const { id, name, label, value, placeholder, fieldStatus, onInputChange, disabled, style } = this.props;
        return (<div className="p-col-12" style={style ? style : {marginTop: '38px'}}>
            <Checkbox 
                name={name}
                inputId={id} 
                value={value} 
                disabled={disabled}
                onChange={onInputChange} 
                checked={value ? true : false} />
            <label htmlFor={id} className="p-checkbox-label">{label}</label>
        </div>)
    }
}


export default CheckBox;